import React, { useEffect, useState } from 'react'
import { ThemeProvider } from '@emotion/react'
import * as styles from 'styles/exports.module.scss'
import AppContext from 'context/app'
import Nav from 'components/nav'
import Footer from 'components/footer'
import Violator from 'components/violator'

export default function Layout({ children }){
    const [clientWidth, setClientWidth] = useState(typeof document !== `undefined` ? document.body.clientWidth : null)
    const [screenWidth, setScreenWidth] = useState(typeof window !== `undefined` ? window.screen.width : null)
    const [screenHeight, setScreenHeight] = useState(typeof window !== `undefined` ? window.screen.height : null)

    // Resize listener
    useEffect(() => {
        if(typeof window === 'undefined') return

        const handleResize = e => {
            setClientWidth(e.target.document.body.clientWidth)
            setScreenWidth(e.target.screen.width)
            setScreenHeight(e.target.screen.height)
        }
        
        window.addEventListener('resize', handleResize)
        
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    const value = {
        clientWidth,
        screenWidth,
        screenHeight,
    }

    const theme = {
        colors: {
            primary: styles.primary,
        },
        fonts: {
            roboto: styles.roboto,
            inter: styles.inter,
        },
        breakpoints: {
            xl: Number(styles.xl),
            lg: Number(styles.lg),
            md: Number(styles.md),
            sm: Number(styles.sm),
            xs: Number(styles.xs),
        },
        queries: {
            xl: `@media(max-width: ${styles.xl}px)`,
            lg: `@media(max-width: ${styles.lg}px)`,
            md: `@media(max-width: ${styles.md}px)`,
            sm: `@media(max-width: ${styles.sm}px)`,
            xs: `@media(max-width: ${styles.xs}px)`,
        },
    }

    return(
        <AppContext.Provider value={value}>
            <ThemeProvider theme={theme}>
                <Nav style={{ zIndex: 2 }} />
                <Violator style={{ zIndex: 1 }} />
                <main>{children}</main>
                <Footer />
            </ThemeProvider>
        </AppContext.Provider>
    )
}
